import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('inviteUserForm');

    return {
        EMAIL_ADDRESS_FIELD_PLACEHOLDER: t('emailAddressFieldPlaceholder'),
        INVITE: t('invite')
    };
};

export default useTranslation;
